import { render } from "./jntAthdcAth.vue?vue&type=template&id=19059a3e&scoped=true"
import script from "./jntAthdcAth.vue?vue&type=script&lang=js"
export * from "./jntAthdcAth.vue?vue&type=script&lang=js"

import "./jntAthdcAth.vue?vue&type=style&index=0&id=19059a3e&scoped=true&lang=css"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19059a3e"]])

export default __exports__